<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Bio:</label>
        <div class="input-group">
          <input type="text" placeholder="Bio" v-model="editBio" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <button class="submit primary" @click="onButtonClick">
          Edit References
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["propsData"],
  watch: {
    refes: function () {
      this.initData();
    },
  },
  data() {
    return {
      editBio: null,
    };
  },
  created: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.editBio = this.propsData;
    },
    onButtonClick: function () {
      this.$emit("onButtonClick", this.editBio);
    },
  },
};
</script>
